module.exports = __webpack_public_path__ + "static/media/img96_R.4e4bfce9.jpg";